exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-gray[data-v-a1661d3c] {\n  -webkit-filter: contrast(0.3);\n          filter: contrast(0.3);\n}\n", ""]);

// exports
